<template>
    <div v-if="info.length != 0">

        <div class="MatchDetail__top">
            <div class="wrapper generic-medium">

                <div class="MatchDetail__left">
                    {{eventType(info.id)}}
                    <div class="MatchDetail__court">
                        {{courtDisplay(info.stat.crt)}} - {{roundDisplay(info.stat.rnd)}}
                    </div>
                </div>

                <div class="MatchDetailCard__status generic-small" :class="{ 'live-match' : matchStatus() === 'Live Match'}">
                    {{matchStatus()}}
                </div>

            </div>
        </div>

        <div class="MatchDetailCard">

            <div class="wrapper">

                <div class="MatchDetailFigure__team">
                    <player-figure :player="info.stat.idA" :assoc="assoc"></player-figure>
                    <player-figure v-if="info.stat.idA2.length > 0":player="info.stat.idA2" :assoc="assoc"></player-figure>


                </div>

                <div class="Match">

                    <div class="Match__body">

                        <div class="Match__line" :class="{ 'Match__line--winner': winner(info.stat.winner , 'a') }">

                            <div class="Match__player__holder">

                                <div class="Match__player">

                                    <img class="small-flag" :src="flagPath + info.stat.cA.toLowerCase() + '.svg'"
                                         :alt="info.stat.cA">

                                    <span class="Match__player__fn generic-medium">{{info.stat.nAF}}</span><span class="Match__player__i generic-medium">{{initial(info.stat.nAF)}}</span>&nbsp;<span
                                        class="Match__player__ln generic-medium">{{info.stat.nAL}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedA">[{{info.stat.seedA}}]</span>
                                    <span class="Match__player__seed"
                                            v-if="showType( 'wc', info.stat.idA )">[WC]</span>

                                </div>

                                <div class="Match__player" v-if="info.stat.isDoubles == 1">

                                    <img class="small-flag" :src="flagPath + info.stat.cA2.toLowerCase() + '.svg'"
                                         :alt="info.stat.cA2">

                                    <span class="Match__player__fn generic-medium">{{info.stat.nA2F}}</span><span class="Match__player__i generic-medium">{{initial(info.stat.nA2F)}}</span>&nbsp;<span
                                        class="Match__player__ln generic-medium">{{info.stat.nA2L}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedA">[{{info.stat.seedA}}]</span>
                                    <span class="Match__player__seed"
                                            v-if="showType( 'wc', info.stat.idA2 )">[WC]</span>

                                </div>

                            </div>

                            <div v-if="info.stat.serve == '0' || info.stat.serve == '2'"
                                 class="Match__serve" v-html="ico_ball">
                            </div>

                            <div v-if="winner(info.stat.winner , 'a')"
                                 class="Match__winner" v-html="ico_winner"></div>

                            <div class="Match__set generic-medium">

                                <ul>
                                    <li class="Match__set__pt" v-if="info.stat.ptA">{{info.stat.ptA}}</li>
                                    <li v-if="info.stat" :class="{Match__set__winner : info.stat.s1A > info.stat.s1B}">
                                        {{info.stat.s1A}}<sup v-if="info.stat.s1A < info.stat.s1B">{{info.stat.tb1}}</sup>
                                    </li>
                                    <li v-else>-</li>

                                    <li v-if="info.stat.s2A" :class="{Match__set__winner : info.stat.s2A > info.stat.s2B}">
                                        {{info.stat.s2A}}<sup v-if="info.stat.s2A < info.stat.s2B">{{info.stat.tb2}}</sup>
                                    </li>
                                    <li v-else>-</li>

                                    <li v-if="info.stat.s3A" :class="{Match__set__winner : info.stat.s3A > info.stat.s3B}">
                                        {{info.stat.s3A}}<sup v-if="info.stat.s3A < info.stat.s3B">{{info.stat.tb3}}</sup>
                                    </li>
                                    <li v-else>-</li>
                                </ul>

                            </div>

                        </div>

                        <div class="Match__line" :class="{ 'Match__line--winner': winner(info.stat.winner , 'b') }">

                            <div class="Match__player__holder">

                                <div class="Match__player">

                                    <img class="small-flag" :src="flagPath + info.stat.cB.toLowerCase() + '.svg'"
                                         :alt="info.stat.cB">

                                    <span class="Match__player__fn generic-medium">{{info.stat.nBF}}</span><span class="Match__player__i generic-medium">{{initial(info.stat.nBF)}}</span>&nbsp;<span
                                        class="Match__player__ln generic-medium">{{info.stat.nBL}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedB">[{{info.stat.seedB}}]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'wc', info.stat.idB )">[WC]</span>

                                </div>

                                <div class="Match__player" v-if="info.stat.isDoubles == 1">

                                    <img class="small-flag" :src="flagPath + info.stat.cB2.toLowerCase() + '.svg'"
                                         :alt="info.stat.cB2">

                                    <span class="Match__player__fn generic-medium">{{info.stat.nB2F}}</span><span class="Match__player__i generic-medium">{{initial(info.stat.nB2F)}}</span>&nbsp;<span
                                        class="Match__player__ln generic-medium">{{info.stat.nB2L}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedB">[{{info.stat.seedB}}]</span>
                                    <span class="Match__player__seed"
                                        v-if="showType( 'wc', info.stat.idB2 )">[WC]</span>


                                </div>

                            </div>

                            <div v-if="info.stat.serve == '1' || info.stat.serve == '3'"
                                 class="Match__serve" v-html="ico_ball">
                            </div>

                            <div v-if="winner(info.stat.winner , 'b')"
                                 class="Match__winner" v-html="ico_winner"></div>

                            <div class="Match__set generic-medium">

                                <ul>

                                    <li class="Match__set__pt" v-if="info.stat.ptB">{{info.stat.ptB}}</li>

                                    <li v-if="info.stat.s1B" :class="{Match__set__winner : info.stat.s1A < info.stat.s1B}">
                                        {{info.stat.s1B}}<sup v-if="info.stat.s1A > info.stat.s1B">{{info.stat.tb1}}</sup>
                                    </li>
                                    <li v-else>-</li>

                                    <li v-if="info.stat.s2B" :class="{Match__set__winner : info.stat.s2A < info.stat.s2B}">
                                        {{info.stat.s2B}}<sup v-if="info.stat.s2A > info.stat.s2B">{{info.stat.tb2}}</sup>
                                    </li>
                                    <li v-else>-</li>

                                    <li v-if="info.stat.s3B" :class="{Match__set__winner : info.stat.s3A < info.stat.s3B}">
                                        {{info.stat.s3B}}<sup v-if="info.stat.s3A > info.stat.s3B">{{info.stat.tb3}}</sup>
                                    </li>
                                    <li v-else>-</li>

                                </ul>

                            </div>

                        </div>

                    </div>

                    <div class="Match__meta">

                        <div class="Match__time generic-small" :class="{ full: info.stat.state == 'F' }">
                            <span v-html="ico_clock"></span>
                            {{matchTime(info.stat.mt)}}
                        </div>

                    </div>

                </div>

                <div class="MatchDetailFigure__team">
                    <player-figure :player="info.stat.idB" :assoc="assoc"></player-figure>
                    <player-figure v-if="info.stat.idB2.length > 0" :player="info.stat.idB2" :assoc="assoc"></player-figure>
                </div>

                <player-name :match="match" :assoc="assoc" :info="info.stat" :flagPath="flagPath"></player-name>

            </div>

        </div>

        <player-name :match="match" :assoc="assoc" :info="info.stat" :flagPath="flagPath"></player-name>

        <div class="MatchDetail__stat" v-if="feed.s1.length > 0">

            <div class="wrapper">

                <h5 class="MatchDetail__stat__caption">Match Statistics</h5>

                <div class="stat-line__holder">

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{aces(0)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value" :style="{ width: aces(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            aces
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{aces(1)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value" :style="{ width: aces(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{double_faults(0)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value" :style="{ width: double_faults(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            double faults
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{double_faults(1)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value" :style="{ width: double_faults(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{first_serve_percentage(0)[0]}}%
                                <span>({{first_serve_percentage(0)[1]}}/{{first_serve_percentage(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: first_serve_percentage(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            1st serve
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{first_serve_percentage(1)[0]}}%
                                <span>({{first_serve_percentage(1)[1]}}/{{first_serve_percentage(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: first_serve_percentage(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{first_serve_points_won(0)[0]}}%
                                <span>({{first_serve_points_won(0)[1]}}/{{first_serve_points_won(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: first_serve_percentage(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            1st serve points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{first_serve_points_won(1)[0]}}%
                                <span>({{first_serve_points_won(1)[1]}}/{{first_serve_points_won(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: first_serve_percentage(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{second_serve_points_won(0)[0]}}%
                                <span>({{second_serve_points_won(0)[1]}}/{{second_serve_points_won(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: second_serve_points_won(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            2nd serve points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{second_serve_points_won(1)[0]}}%
                                <span>({{second_serve_points_won(1)[1]}}/{{second_serve_points_won(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: second_serve_points_won(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{break_points_saved(1)[0]}}%
                                <span>({{break_points_saved(1)[1]}}/{{break_points_saved(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: break_points_saved(1)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            break points saved
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{break_points_saved(0)[0]}}%
                                <span>({{break_points_saved(0)[1]}}/{{break_points_saved(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: break_points_saved(0)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{service_games_played(0)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: service_games_played(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            service games played
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{service_games_played(1)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: service_games_played(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{first_return_points_won(1)[0]}}%
                                <span>({{first_return_points_won(1)[1]}}/{{first_return_points_won(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: first_return_points_won(1)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            1st return points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{first_return_points_won(0)[0]}}%
                                <span>({{first_return_points_won(0)[1]}}/{{first_return_points_won(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: first_return_points_won(0)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{second_return_points_won(1)[0]}}%
                                <span>({{second_return_points_won(1)[1]}}/{{second_return_points_won(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: second_return_points_won(1)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            2nd return points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{second_return_points_won(0)[0]}}%
                                <span>({{second_return_points_won(0)[1]}}/{{second_return_points_won(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: second_return_points_won(0)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{break_points_won(0)[0]}}%
                                <span>({{break_points_won(0)[1]}}/{{break_points_won(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: break_points_won(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            break points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{break_points_won(1)[0]}}%
                                <span>({{break_points_won(1)[1]}}/{{break_points_won(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: break_points_won(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{return_games_played(1)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: return_games_played(1)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            return games played
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{return_games_played(0)[1]}}</div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: return_games_played(0)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{total_service_points_won(0)[0]}}%
                                <span>({{total_service_points_won(0)[1]}}/{{total_service_points_won(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: total_service_points_won(0)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            total service points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{total_service_points_won(1)[0]}}%
                                <span>({{total_service_points_won(1)[1]}}/{{total_service_points_won(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: total_service_points_won(1)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>
                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{total_return_points_won(1)[0]}}%
                                <span>({{total_return_points_won(1)[1]}}/{{total_return_points_won(1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: total_return_points_won(1)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            total return points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{total_return_points_won(0)[0]}}%
                                <span>({{total_return_points_won(0)[1]}}/{{total_return_points_won(0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: total_return_points_won(0)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>
                    <div class="stat-line">
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{total_points_won(0, 1)[0]}}% <span>({{total_points_won(0,
                            1)[1]}}/{{total_points_won(0, 1)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: total_points_won(0, 1)[0] + '%' }"></div>
                            </div>
                        </div>
                        <div class="stat-line__info generic-medium">
                            total points won
                        </div>
                        <div class="stat-line__player">
                            <div class="stat-line__value">{{total_points_won(1, 0)[0]}}% <span>({{total_points_won(1,
                            0)[1]}}/{{total_points_won(1, 0)[2]}})</span>
                            </div>
                            <div class="stat-line__percent">
                                <div class="stat-line__percent__value"
                                     :style="{ width: total_points_won(1, 0)[0] + '%' }"></div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div class="news__related" v-if="news.news.length > 0">

            <div class="wrapper">

                <h3 class="title-with-border">
                    Related
                </h3>
                <div class="grid three">

                    <div class="block block-load-more" v-for="post in news.news">

                        <a  class="news__block item"
                            :href=" post.acf.post_type === 'external' ? post.acf.external_link : post.guid "
                            :target="post.acf.post_type === 'external' ? '_blank' : ''">

                            <figure  class="news__block__image" v-html="post.featured_media">
                            </figure>

                            <div class="news__block__image vue-trick">

                                <div class="news__block__icon" v-if="post.acf.post_type == 'video'" v-html="ico_video">
                                </div>

                                <div class="news__block__icon" v-if="post.acf.post_type == 'gallery'" v-html="ico_gallery">
                                </div>

                                <div class="news__block__icon" v-if="post.acf.post_type == 'external'" v-html="ico_external">
                                </div>

                            </div>

                            <div class="news__block__content">

                                <div class="single-news__categories" v-if="post.category">
                                    <div class="single-news__category" v-for="categ in post.category">
                                        {{categ.cat_name}}
                                    </div>
                                </div>

                                <h4>
                                    {{post.post_title}}
                                </h4>

                                <div class="single-news__date generic-small">
                                    {{transformDate(post.post_date)}}
                                </div>

                            </div>

                        </a>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import MatchDetailFigure from './MatchDetailFigure'
    import MatchDetailDetail from './MatchDetailPlayer'

    export default {
        components: {
            'player-figure': MatchDetailFigure,
            'player-name': MatchDetailDetail
        },
        props: ['match', 'assoc', 'flag'],
        data() {
            return {
                info: [],
                setInfo: [],
                feed: [],
                news: [],
                news: {
                    news: [] // Your news array goes here
                },
                ico_winner: window.ico_tick,
                ico_pointer_right: window.ico_pointer_right,
                ico_ball: window.ico_ball,
                ico_clock: window.ico_clock,
                ico_external: window.ico_external,
                ico_gallery: window.ico_gallery,
                ico_video: window.ico_video,
                formattedDate: "",
                flagPath: this.flag + '/assets/dist/svg/flags/'
            }
        },
        created() {
            this.getFeed()

            let app = this
            setInterval(function () {
                app.getFeed()
            }, 15 * 1000, app)
        },
        computed: {
            roundName(){
                let roundId = this.info.stat.rnd

                if(this.info.stat.isDoubles == 1){
                    if (roundId == '1' || roundId == 'R32' || roundId == 'First Round') {
                        return 'R32';
                    }

                    if (roundId == '2' || roundId == 'R16' || roundId == 'Second Round') {
                        return 'R16';
                    }

                    if (roundId == '5' || roundId == 'Q') {
                        return 'Quarterfinals';
                    }

                    if (roundId == '6' || roundId == 'S') {
                        return 'Semifinals';
                    }

                    if (roundId == '7' || roundId == 'F') {
                        return 'Final';
                    }
                }else if(this.info.stat.isQuals == 1){
                    if (roundId == '1' || roundId == 'Q1') {
                        return 'Round 1';
                    }

                    if (roundId == '2' || roundId == 'Q2' || roundId == 'Q4') {
                        return 'Round 2';
                    }

                }else{

                   if (roundId == '1' ) {
                        return 'R128';
                    }

                    if (roundId == '2' || roundId == 'R64') {
                        return 'R64';
                    }

                    if (roundId == '3' || roundId == 'R32' || roundId == 'First Round') {
                        return 'R32';
                    }

                    if (roundId == '4' || roundId == 'R16' || roundId == 'Second Round') {
                        return 'R16';
                    }

                    if (roundId == '5' || roundId == 'Q') {
                        return 'Quarterfinals';
                    }

                    if (roundId == '6' || roundId == 'S') {
                        return 'Semifinals';
                    }

                    if (roundId == '7' || roundId == 'F') {
                        return 'Final';
                    }
                }

            }

        },
        methods: {
            fetchData() {

                var playerIds = [this.feed.stat.idA, this.feed.stat.idB, this.feed.stat.idA2, this.feed.stat.idB2];

                playerIds = playerIds.filter(v=>v!='')

                axios.post('/wp-json/matchstats/v1/posts', { player_ids: playerIds })
                    .then(response => {
                        this.news = response.data
                        // console.log(this.news.news)
                    })
                    .catch(error => {
                    // Handle any errors that occur during the AJAX request
                        console.error(error);
                    });

            },
            transformDate(time) {
                const dateObj = new Date(time);

                const options = { year: 'numeric', month: 'short', day: 'numeric' };
                const formattedDate = dateObj.toLocaleDateString('en-US', options);

                return formattedDate;
            },
            matchStatus() {
                // console.log(this.info.stat)
                if (this.info.stat.state == 'F') {
                    return 'Completed'
                }

                if (this.info.stat.state == 'P') {
                    return 'Live Match'
                }

                if (this.info.stat.state == 'M') {
                    return 'In Progress'
                }

                if (this.info.stat.state == 'W') {
                    return 'Warmup'
                }

                if (this.info.stat.state == 'C') {
                    return 'On court'
                }

                if (this.info.stat.state == 'S') {
                    return 'Suspended'
                }

                if (match.detail.state == 'G') {
                    return 'Players Arrived'
                }

                if (match.detail.state == 'T') {
                    return 'Time Announcement'
                }

                return this.info.stat.state
            },
            winner(winner, team) {
                if (team == 'a' && winner != '' && (winner == this.info.stat.idA || winner == '2' || winner == '4' || winner == '6')) {
                    return true
                }

                if (team == 'b' && winner != '' && (winner== this.info.stat.idB || winner == '3' || winner == '5' || winner == '7')) {
                    return true
                }


                return false
            },
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            matchTime(time) {
                if (time.length < 6) {
                    return time + ':00'
                }

                return time.slice(0, 5);
            },
            messageFormat(detail) {

                if (detail.msg == '') {
                    return ''
                }

                let messages = detail.msg.match(/{(.*?)}/)
                let messageParts = messages[0].slice(1, -1).split('|')

                if (messageParts[0] == '1') {
                    return 'Match point'
                }

                if (messageParts[0] == '2') {
                    return `${messageParts[1]} match points`
                }

                if (messageParts[0] == '3') {
                    return 'Break point'
                }

                if (messageParts[0] == '4') {
                    return `${messageParts[1]} break points`
                }

                if (messageParts[0] == '5') {
                    return 'Set point'
                }

                if (messageParts[0] == '6') {
                    return `${messageParts[1]} set points`
                }

                if (messageParts[0] == '7') {
                    return '2nd serve'
                }

                if (messageParts[0] == '8') {
                    return `Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '9') {
                    return `Ace  - ${messageParts[1]} for ${messageParts[2]}`
                }
                if (messageParts[0] == '10') {
                    return `Ace on 2nd serve – ace #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '11') {
                    return ''
                    return `Winner: ${messageParts[1]}`
                }

                if (messageParts[0] == '12') {
                    return ''
                    return `Winners ${messageParts[1]}`
                }

                if (messageParts[0] == '13') {
                    return `Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '14') {
                    return `Ace ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '15') {
                    return `Ace on 2nd serve ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '16') {
                    return 'Match suspended – rain'
                }

                if (messageParts[0] == '17') {
                    return 'Match suspended – darkness'
                }

                if (messageParts[0] == '18') {
                    return 'Match suspended – heat'
                }

                if (messageParts[0] == '19') {
                    return 'Match suspended'
                }

                if (messageParts[0] == '20') {
                    return 'by retirement'
                }

                if (messageParts[0] == '21') {
                    return `Point penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '22') {
                    return `Game penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '23') {
                    return `Time penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '24') {
                    return 'by default'
                }

                if (messageParts[0] == '25') {
                    return 'Game point'
                }

                if (messageParts[0] == '26') {
                    return `${messageParts[1]} game points`
                }

                if (messageParts[0] == '27') {
                    return 'Foot fault – 2nd serve'
                }

                if (messageParts[0] == '28') {
                    return `Foot fault – Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '29') {
                    return `Foot fault – Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '30') {
                    return 'Let'
                }

                return ''

            },
            roundDisplay(round) {
                if (round == '1' || round == 'R32' || round == 'First Round')
                    return 'Round 1'
                else if (round == '2' || round == 'R16' || round == 'Second Round')
                    return 'Round 2'
                else if (round == '3')
                    return 'Round 3'

                if (this.type == 'wta') {

                    if (round == 'Q')
                        return 'Quarterfinals'
                    else if (round == 'S')
                        return 'Semifinals'
                    else if (round == 'F')
                        return 'Final'
                } else {
                    if (round == '5')
                        return 'Quarterfinals'
                    else if (round == '6')
                        return 'Semifinals'
                    else if (round == '7')
                        return 'Final'
                }

                if(round == 'F')
                    return 'Final'

                if ( round == 'Q1' || round == 'R1' )
                    return 'Round 1'
                else if ( round == 'Q2' || round == 'R2' || round == "Q4" )
                    return 'Round 2'

                return round;
            },
            eventType(matchID){
                if(matchID.includes('MS')){
                    return "Men's Singles"
                }else if(matchID.includes('MD')){
                    return "Men's Doubles"
                }else if(matchID.includes('QS')){
                    return "Men's Qualifying"
                }else if(matchID.includes('LS')){
                    return "Women's Singles"
                }else if(matchID.includes('LD')){
                    return "Women's Doubles"
                }else if(matchID.includes('RS')){
                    return "Women's Qualifying"
                }
            },
            getFeed() {

                axios.get(`${window.feed_ip}/get/${this.assoc}/${window.tournament}/${this.match}`).then(response => {

                    this.feed = response.data
                    this.info = response.data

                    this.fetchData();

                    if(this.info.stat.isDoubles == "" && this.feed.id.substring(0, 2) == "MD"){
                        this.info.stat.isDoubles = 1;
                    }

                    // Would be nice to refactor this… nevertheless it works
                    let setInfo = []

                    if (response.data.length != 0) {
                        setInfo.push(...response.data.s1)
                        setInfo.push(...response.data.s2)
                        setInfo.push(...response.data.s3)

                        for (let sv in setInfo[2]) {

                            setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[2][sv])

                        }

                        for (let sv in setInfo[3]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[3][sv])

                        }

                        if (setInfo[4]) {

                            for (let sv in setInfo[4]) {

                                setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[4][sv])

                            }

                        }

                        for (let sv in setInfo[5]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[5][sv])

                        }

                        this.setInfo = setInfo
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            aces(team) {

                let percent = 0
                let total = parseInt(this.setInfo[0].aces) + parseInt(this.setInfo[1].aces)

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].aces) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].aces)]

            },
            double_faults(team) {

                let percent = 0
                let total = parseInt(parseInt(this.setInfo[0].dbl_flt)) + parseInt(parseInt(this.setInfo[1].dbl_flt))

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].dbl_flt) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].dbl_flt)]

            },
            first_serve_percentage(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].good_1st_serv) / parseInt(this.setInfo[team].tot_serv)) * 100),
                    parseInt(this.setInfo[team].good_1st_serv),
                    parseInt(this.setInfo[team].tot_serv)
                ]

            },
            first_serve_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].pts_1st_serv) / parseInt(this.setInfo[team].good_1st_serv)) * 100),
                    parseInt(this.setInfo[team].pts_1st_serv),
                    parseInt(this.setInfo[team].good_1st_serv)
                ]

            },
            second_serve_points_won(team) {

                if ((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv)) / (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))) * 100),
                    (parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv)),
                    (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))
                ]

            },
            break_points_saved(team) {

                if (parseInt(this.setInfo[team].break_pts) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].break_pts) - parseInt(this.setInfo[team].break_n)) / parseInt(this.setInfo[team].break_pts)) * 100),
                    (parseInt(this.setInfo[team].break_pts) - parseInt(this.setInfo[team].break_n)),
                    parseInt(this.setInfo[team].break_pts)
                ]

            },
            service_games_played(team) {

                let percent = 0
                let total = parseInt(parseInt(this.setInfo[0].sgPlayed)) + parseInt(parseInt(this.setInfo[1].sgPlayed))

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].sgPlayed) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].sgPlayed)]

            },
            first_return_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].good_1st_serv) - parseInt(this.setInfo[team].pts_1st_serv)) / parseInt(this.setInfo[team].good_1st_serv)) * 100),
                    (parseInt(this.setInfo[team].good_1st_serv) - parseInt(this.setInfo[team].pts_1st_serv)),
                    parseInt(this.setInfo[team].good_1st_serv)
                ]

            },
            second_return_points_won(team) {

                if ((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) - (parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv))) / (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))) * 100),
                    ((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) - (parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv))),
                    (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))
                ]

            },
            break_points_won(team) {

                if (parseInt(this.setInfo[team].break_pts) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].break_n) / parseInt(this.setInfo[team].break_pts)) * 100),
                    parseInt(this.setInfo[team].break_n),
                    parseInt(this.setInfo[team].break_pts)
                ]

            },
            return_games_played(team) {

                let percent = 0
                let total = parseInt(parseInt(this.setInfo[0].sgPlayed)) + parseInt(parseInt(this.setInfo[1].sgPlayed))

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].sgPlayed) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].sgPlayed)]

            },
            total_service_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].pts_to_serv) / parseInt(this.setInfo[team].tot_serv)) * 100),
                    parseInt(this.setInfo[team].pts_to_serv),
                    parseInt(this.setInfo[team].tot_serv)
                ]

            },
            findPlayerById( playerId ) {
                if ( playerId == '' )
                    return false

                let found = window.all_players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.is_wild_card == true )
                    return true

                return false;
            },
            total_return_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].pts_to_serv)) / parseInt(this.setInfo[team].tot_serv)) * 100),
                    (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].pts_to_serv)),
                    parseInt(this.setInfo[team].tot_serv)
                ]

            },
            total_points_won(teamA, teamB) {

                if(this.setInfo[teamA].tot_pts == '' && this.setInfo[teamB].tot_pts == ''){
                    return ['0', '0', '0']
                }
                if ((parseInt(this.setInfo[teamA].tot_pts) + parseInt(this.setInfo[teamB].tot_pts)) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[teamA].tot_pts) / (parseInt(this.setInfo[teamA].tot_pts) + parseInt(this.setInfo[teamB].tot_pts))) * 100),
                    parseInt(this.setInfo[teamA].tot_pts),
                    (parseInt(this.setInfo[teamA].tot_pts) + parseInt(this.setInfo[teamB].tot_pts))
                ]

            }
        }
    }
</script>
